'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/search-toggle.js';
import './modules/password-form-page.js';
import './modules/carousel-section.js';
import './modules/norient-route-map.js';
import './modules/animations.js';

import 'animate.css';
